import type { BoundActions, HookActionsFunction, HookFunction, Store } from 'react-sweet-state';
import { createStore, createHook, createActionsHook } from 'react-sweet-state';
type SideNavigationCollapsedState = {
	isCollapsed: boolean;
};
const initialState: SideNavigationCollapsedState = {
	isCollapsed: false,
};
const actions = {
	setIsCollapsed:
		(collapsed: boolean) =>
		({ setState }: any): void => {
			setState({ isCollapsed: collapsed });
		},
};
export const SideNavigationCollapsedStore: Store<
	SideNavigationCollapsedState,
	{
		setIsCollapsed: (collapsed: boolean) => ({ setState }: any) => void;
	}
> = createStore({
	initialState,
	actions,
});

export const useSideNavigationCollapsedState: HookFunction<
	SideNavigationCollapsedState,
	BoundActions<
		SideNavigationCollapsedState,
		{
			setIsCollapsed: (collapsed: boolean) => ({ setState }: any) => void;
		}
	>,
	void
> = createHook(SideNavigationCollapsedStore);

export const useSideNavigationCollapsedActions: HookActionsFunction<
	BoundActions<
		SideNavigationCollapsedState,
		{
			setIsCollapsed: (collapsed: boolean) => ({ setState }: any) => void;
		}
	>
> = createActionsHook(SideNavigationCollapsedStore);
